import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import { WellString } from 'app/modules/cdft/model/cdft.model';

@Injectable({ providedIn: 'root' })
export class WellStringState extends State<WellString> implements WellString {
    id: string;
    wellId: string;
    wellboreId: string;
    stringLongName: string;
    stringShortName: string;
    stringStatus: string;
    stringIndicatorLongName: string;
    stringIndicatorShortName: string;
    reservoirZone: string;
    tubingSize: number;
    inputDate: string;
    inputBy: string;
    updateDate: string;
    updateBy: string;
    isDeleted: boolean;
    activityPlans: any[];
    cmBaseEmergings: any[];
    pmCdftResults: any[];
    pmRegisters: any[];
    sceScssvs: any[];
    sceWellHeads: any[];
    sceXmasTrees: any[];
    scssvMaintenances: any[];
    well: any;
    wellFlowCategories: any[];
    wellProductionStatuses: any[];
    wellTypes: any[];
    wellbore: any;
    wpbDetails: any[];
    cdftHeaders: any[];
    dailyActivityTrackers: any[];
    wrsvRegisters: any[];
    annulusPressureRecords: any[];
    aprRegisters: any[];
    cmRegisters: any[];
    failureNotifications: any[];
    wellHealthinesses: any[];
    correctiveMaintenances: any[];
}
